module.exports = __webpack_public_path__ + "img/1 (99).193e4da4.png";